module.exports = __webpack_public_path__ + "img/direction-down.20b00f31.svg";